export default {};
//# sourceMappingURL=plugin.js.map